<template>
  <div class="car-archive-details">
    <div class="car-archive-details-content">
      <!-- 车辆信息 -->
      <div class="car">
        <div class="title">车辆信息</div>
        <div class="row">
          <div v-for="(i, index) in carInfo" :key="index">
            <span>{{ i.name }}</span>
            <span>{{ i.value }}</span>
          </div>
        </div>
      </div>
      <div class="export-excel">
        <el-button class="btn-blue" @click="exportExcel">导出</el-button>
      </div>
      <div class="table">
        <el-table ref="table" :data="carArchivelTable" style="width: 100%">
          <el-table-column 
            v-for="(item, index) in carArchiveTableTitleList"
            :key="index"
            :label="item.label"
            :prop="item.prop"
            :min-width="item.width"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <el-image
                v-if="item.prop === 'imgUrl'"
                :src="scope.row.imgUrl"
                :preview-src-list="[scope.row.imgUrl]"
                @load="onImageLoad"
              >
                <div slot="error" class="image-slot">
                  <i class="el-icon-picture-outline"></i>
                </div>
              </el-image>
              <div v-else  style="
                        overflow: hidden;
                        white-space: nowrap;
                        text-overflow: ellipsis;">
                <span>{{ scope.row[item.prop] }}</span> 
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
import { modifyNetTitle, formaTimeToAllSecond } from "common/js/util";
import SmartVehicleInspection from "models/smart-vehicle-inspection/smart-vehicle-inspection";
export default {

  data() {
    return {
      id: null,
      carInfo: [
        {name: '车架号：', value: ''},
        {name: '作业类型：', value: ''},
        {name: '采集员：', value: ''},
        {name: '车辆情况：', value: ''},
        {name: '图像数量：', value: ''},
        {name: '采集时间：', value: ''}
      ],
      carArchivelTable: [],
      carArchiveTableTitleList: [
        {label: '车辆图片', prop: 'imgUrl', width: '80'},
        {label: '留痕项目', prop: 'traceItem', width: ''},
        {label: '涉及部位', prop: 'partName', width: '200'},
        {label: '车辆情况', prop: 'vehicleStatusVal', width: '100'},
        {label: '异常备注', prop: 'damageRemark', width: '180'}
      ],
      /** 原图自然宽度（用于动态调整水印字号） */
      imageNaturalWidth: 0,
      /**
       * 水印文字底衬（背景色）所用的 OSS Object 完整路径。
       * OSS 文字水印本身不支持背景色，需先用一张 1×1 的纯黑 PNG 作为图片水印，
       * 通过 image/resize,m_fixed 强制拉伸成文字块大小的半透明矩形垫在文字下方。
       * 该文件需提前上传到当前 Bucket（根目录下 watermark-bg.png）；留空则不绘制背景色。
       */
      WATERMARK_BG: '',
      /** 底衬透明度 [0,100]，100 为完全不透明 */
      WATERMARK_BG_OPACITY: 45
    }
  },

  created() {
    modifyNetTitle('车辆影像档案详情')
    this.id = Number(this.$route.query.id)
    this.initDetails()
  },

  mounted() {
    // el-image 2.13.0 的预览遮罩本身不响应点击，这里统一在捕获阶段拦截
    document.addEventListener('click', this.handleViewerMaskClick, true)
  },

  beforeDestroy() {
    document.removeEventListener('click', this.handleViewerMaskClick, true)
  },

  methods: {
    initDetails() {
      SmartVehicleInspection.getCarArchiveDetails(this.id).then(res => {
        if (res.success) {
          const { vin, vehicleStatus, jobType, collectorName, photos, submitTime } = res.result
          this.carInfo = [
            {name: '车架号：', value: vin},
            {name: '作业类型：', value: jobType === 1?'接收检验':'移交检验'},
            {name: '采集员：', value: collectorName},
            {name: '车辆情况：', value: vehicleStatus === 0?'正常':'有质损'},
            {name: '图像数量：', value: photos.length},
            {name: '采集时间：', value: submitTime ? formaTimeToAllSecond(submitTime) : ''},
          ]
          let arr = []
          photos.map(item => {
            let obj = {}
            obj.imgUrl = this.watermarkedUrl(item.ossUrl, item.shootTime, item.shootLocation)
            obj.vehicleStatusVal = item.damageFlag === 0?'正常':'有质损'
            obj.traceItem = item.traceItem
            obj.partName = item.partName
            obj.damageFlag = item.damageFlag
            obj.damageRemark = item.damageRemark
            arr.push(obj)
          })
          this.carArchivelTable = arr
        }
      })
    },

    /** 图片加载完成回调：记录自然宽度以动态调整水印 */
    onImageLoad(e) {
      const img = e.target
      if (img.naturalWidth) this.imageNaturalWidth = img.naturalWidth
    },

    /** UTF-8 字符串 → URL-safe Base64（OSS text 参数格式） */
    ossBase64(str) {
      const utf8 = new TextEncoder().encode(str);
      let binary = '';
      utf8.forEach(byte => binary += String.fromCharCode(byte));
      const b64 = btoa(binary);
      return b64.replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '')
    },

    /**
     * 带水印的照片 URL：
     * - OSS URL（http/https 开头）→ 拼接 x-oss-process=image/watermark
     *   水印内容：yyyy-MM-dd HH:mm:ss + 地址，位置右下角
     * - 非 OSS URL（base64 本地图）→ 原样返回
     */
    watermarkedUrl(imguUrl, locationTime, tempAddress) {
      if (!imguUrl) return ''
      const baseUrl = imguUrl
      if (!baseUrl || !baseUrl.startsWith('http')) return baseUrl
      
      const dt = locationTime
      const addr = tempAddress
      if (!dt) return baseUrl

      /** 将字符串按 UTF-8 字节拆分为 ≤63 字节的块（汉字 3 字节，在字符边界切分） */
      const splitByBytes = (str, maxBytes = 63) => {
        const chunks = []
        let cur = ''
        let curBytes = 0
        for (const char of str) {
          const charBytes = new TextEncoder().encode(char).length
          
          if (curBytes + charBytes > maxBytes) {
            if (cur) chunks.push(cur)
            cur = char
            curBytes = charBytes
          } else {
            cur += char
            curBytes += charBytes
          }
        }
        if (cur) chunks.push(cur)
        return chunks
      }

      const sep = baseUrl.includes('?') ? '&' : '?'
      const sz = 10
      const xOff = 6
      const yBase = 10
      const pad = 4 // 底衬相对文字的内边距
      const lineHeight = Math.round(sz * 1.6) // 行高随字号联动

      // 地址拆分为多块（每块 ≤63 字节）
      const addrChunks = addr ? splitByBytes(addr) : []
      // 自上而下的文字行：日期时间 + 地址各块
      const lines = [dt, ...addrChunks]

      // 估算单行文字宽度（汉字按 1em，其余按 0.55em）
      const lineWidth = s => {
        let w = 0
        for (const ch of s) w += /[\u2e80-\u9fff\uff00-\uffef\u3000-\u303f]/.test(ch) ? sz : sz * 0.55
        return w
      }
      const maxTextW = Math.ceil(Math.max(...lines.map(lineWidth)))
      const canvasW = this.imageNaturalWidth || 374
      // 底衬矩形尺寸：宽度包住最长行、高度包住所有行
      const bandW = Math.max(1, Math.min(Math.round(maxTextW * 1.08) + pad * 2, canvasW))
      const bandH = Math.max(1, lines.length * lineHeight + pad)

      let process = `image/resize,w_374,h_618`

      // 1) 背景底衬：1×1 黑图强制拉伸为目标矩形，再叠加透明度，位置与文字块右下角对齐
      if (this.WATERMARK_BG) {
        const bgObj = `${this.WATERMARK_BG}?x-oss-process=image/resize,m_fixed,w_${bandW},h_${bandH}`
        process += `/watermark,image_${this.ossBase64(bgObj)},t_${WATERMARK_BG_OPACITY},g_se,x_${Math.max(0, xOff - pad)},y_${Math.max(0, yBase - pad)}`
      }

      // 2) 文字水印：日期时间在最上方
      process += `/watermark,text_${this.ossBase64(dt)},g_se,size_${sz},color_FFFFFF,shadow_100,x_${xOff},y_${yBase + addrChunks.length * lineHeight}`
      // 地址块自上而下排列
      addrChunks.forEach((chunk, i) => {
        const y = yBase + (addrChunks.length - 1 - i) * lineHeight
        process += `/watermark,text_${this.ossBase64(chunk)},g_se,size_${sz},color_FFFFFF,shadow_100,x_${xOff},y_${y}`
      })
      return `${baseUrl}${sep}x-oss-process=${process}`
    },

    exportExcel() {
      SmartVehicleInspection.getSimultaneousExportOfBicycles(this.id).then(res => {
        let blob = new Blob([res.data], { type: res.headers.contentType });
        let fileName = window.decodeURI(
          res.headers["content-disposition"].split("=")[1]
        );
        var url = URL.createObjectURL(blob);
        var a = document.createElement("a");
        a.href = url;
        a.download = fileName;
        a.click();
        // 释放之前创建的URL对象
        window.URL.revokeObjectURL(url);
      });
    },

    /** 点击预览遮罩关闭大图：遮罩是当前可见 viewer 的直接子元素，取其 close 按钮触发关闭 */
    handleViewerMaskClick(e) {
      const target = e.target
      if (!target || !target.classList || !target.classList.contains('el-image-viewer__mask')) return
      const wrapper = target.parentElement
      const closeBtn = wrapper && wrapper.querySelector('.el-image-viewer__close')
      if (closeBtn) closeBtn.click()
    }
  }
}
</script>

<style lang='scss' scoped>
.car-archive-details {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  .car-archive-details-content {
    height: 100%;
    padding: 24px 30px;
    background: #fff;
    border-radius: 8px;
    .title {
      font-size: 16px;
      font-weight: 400;
      color: #333333;
      margin-bottom: 20px;
    }
    .car {
      width: 100%;
      border-bottom: 1px solid #eee;
      padding-bottom: 24px;
      margin-bottom: 24px;
      .row {
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        row-gap: 24px;
        column-gap: 24px;
        font-size: 14px;
        font-weight: 400;
        color: #666666;
      }
    }
    .export-excel  {
      display: flex;
      justify-content: flex-end;
      margin-bottom: 16px;
    }
    .el-image {
      width: 34px;
      height: 34px;
      .image-slot {
        height: 34px;
        display: flex;
        justify-content: center;
        align-items: center;
        i {
          font-size: 28px;
        }
      }
    }
    ::v-deep.table .el-table .el-table__body-wrapper .el-table__body tr td .cell, 
    ::v-deep.table .el-table .el-table__fixed-body-wrapper .el-table__body tr td .cell {
      height: 40px;
      line-height: 40px;
      display: flex;
      align-items: center;
    }
    ::v-deep .el-icon-circle-close {
      color: #fff
    }
  }
}
</style>
